import firebase from 'firebase'

let config = {
  apiKey: ' AIzaSyBwaTeXAcOZGgamEQ7wnVTRGQMGi7_ASvo ',
  authDomain: 'hcg-org-nz.firebaseapp.com',
  databaseURL: 'https://hcg-org-nz.firebaseio.com',
  projectId: 'hcg-org-nz'
}

const firebaseApp = firebase.initializeApp(config)
export const db = firebaseApp.database()



// WEBPACK FOOTER //
// ./src/firebase.js